import styled from 'styled-components';

interface FormGroupProps {
  fullWidth?: boolean;
  gap?: string;
}

export const FormGroup = styled.div<FormGroupProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.gap || '0.5rem'};
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};
`;